export default __webpack_public_path__ + "static/media/Anvilrage.d05c6687.jpg";